.ax{overflow:hidden;}